import React from "react";
import LoadingWhite from "../../assets/loading/laoding-white.svg";

export default function ButtonSubmit({ loading, text }) {
  return (
    <button
      className="w-full bg-[#38AAEA] hover:bg-blue-dark text-white rounded-md h-10 mt-4 my-1 font-bold"
      type="submit"
    >
      {loading ? (
        <img
          src={LoadingWhite}
          alt=""
          className="w-full items-center justify-center h-8"
        />
      ) : (
        text
      )}
    </button>
  );
}
